let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3PNKQ")).then(() => parcelRequire('jH0B9'));